/* eslint-env jquery */
( $ => {
  const highRes = 3840;

  $( '.bs-div--home-eco-system-logo-wrapper, .bs-div--integrations-banner--logo-wrapper' ).each( ( index, element ) => {
    const currentElement = $( element ),
      currentElementWidth = currentElement.width(),
      clonedElement = currentElement.find( '.bs-div__inner .media-elements' ),
      appendCount = Math.ceil( highRes / currentElementWidth );

    for ( let index = 0; index < appendCount; index++ ) {
      currentElement.find( '.bs-div__inner' ).append( clonedElement.clone() );
    }
  } );
} )( jQuery );
